'use es6';

import http from 'hub-http/clients/apiClient';
/**
 * GET content-settings/v1/site-settings/by-portal-id/:portalId
 */

export function fetch(portalId) {
  return http.get(`content-settings/v1/site-settings/by-portal-id/${portalId}`, {
    query: {
      casing: 'snake'
    }
  });
}